import { useState, useEffect } from 'react';
import { IconButton, useTheme } from "@mui/material";
import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import RateReviewIcon from '@mui/icons-material/RateReview';
import Axios from 'axios';
import { getAuthHeader } from '../../utils/authToken';
import TeacherReviewsModal from './TeacherReviewsModal';

const StyledBadge = styled(Badge)(() => ({
    '& .MuiBadge-badge': {
        right: -1,
        top: 1,
        padding: '0 4px',
    },
}));

const TeacherReviews = () => {
    const theme = useTheme();
    const [reviewSessions, setReviewSessions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);

    const fetchReviewSessions = async () => {
        try {
            const response = await Axios.get(
                `${process.env.REACT_APP_URL}/api/v1/teacher-reviews/sessions`,
                {
                    headers: {
                        Authorization: getAuthHeader(),
                    },
                }
            );
            setReviewSessions(response.data.sessions || []);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching teacher review sessions:", error);
            setReviewSessions([]);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReviewSessions();
        
        // Refresh every 30 seconds
        const interval = setInterval(() => {
            fetchReviewSessions();
        }, 30000);

        return () => clearInterval(interval);
    }, []);

    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        // Refresh sessions when modal closes
        fetchReviewSessions();
    };

    // Count sessions that have pending reviews
    const sessionsWithPendingReviews = reviewSessions.filter(session => 
        session.my_progress?.remaining_items > 0
    ).length;

    return (
        <>
            <IconButton
                onClick={handleOpenModal}
                style={{ marginRight: '10px' }}
                title="Teacher Reviews"
            >
                {theme.palette.mode === "light" ? (
                    <StyledBadge 
                        badgeContent={sessionsWithPendingReviews} 
                        max={99} 
                        color="warning"
                        invisible={sessionsWithPendingReviews === 0}
                    >
                        <RateReviewIcon color="secondary" />
                    </StyledBadge>
                ) : (
                    <StyledBadge 
                        badgeContent={sessionsWithPendingReviews} 
                        max={99} 
                        color="error"
                        invisible={sessionsWithPendingReviews === 0}
                    >
                        <RateReviewIcon color="secondary" />
                    </StyledBadge>
                )}
            </IconButton>

            <TeacherReviewsModal
                open={modalOpen}
                handleClose={handleCloseModal}
                reviewSessions={reviewSessions}
                loading={loading}
                refreshSessions={fetchReviewSessions}
            />
        </>
    );
};

export default TeacherReviews;